import styled from 'styled-components'
import { CLIENT_STYLINGS, size } from '../../../../utils/constants'
import { getBorderRadius, getShadow } from '../../../../utils/styleUtils'

export const GridWrapper = styled.div`
  background-color: transparent;
  width: 100%;
`

export const TrophyContainer = styled.div`
  position: absolute;
  width: 32px;
  height: 28px;
  left: 16px;
  top: 12px;
  border-radius: 8px;
  background-color: ${props =>
    props.label_top === 'gold' ? '#FFBB32' : '#DCDBDD'};
`

export const TrophyImage = styled.svg`
  position: absolute;
  top: 4px;
  left: 6px;
  width: 20px;
  height: 20px;
`

export const ItemImageWrapper = styled.div`
  position: relative;
  margin-bottom: 10px;
`

export const ItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: ${size.laptop}) {
    justify-content: space-around;
  }
`

export const GridItemWrapper = styled.a`
  width: ${props => {
    return props?.itemsPerRow === 3 ? '32%' : '48%'
  }};
  margin-right: 1.25%;
  margin-bottom: 15px;

  @media (max-width: ${size.tablet}) {
    width: 100%;
    margin-left: 0;
    margin-right: 0px;
  }
`

export const GridItemDetailsWrapper = styled.div`
  border-radius: ${props => getBorderRadius(props, 'lg')};
  box-shadow: ${props => getShadow(props, 'sm')};
  height: 100%;
  overflow: hidden;
  background-color: #ffffff;
  -webkit-transition: 0.25s ease;
  -moz-transition: 0.25s ease;
  -o-transition: 0.25s ease;
  transition: 0.25s ease;

  &:hover {
    transform: scale(1.025);
    cursor: pointer;
    background: #f6f6f6;
    box-shadow: ${props => getShadow(props, 'md')};
  }
`

export const ItemImage = styled.div`
  position: relative;
  height: 150px;
  background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.05),
      rgba(0, 0, 0, 0.15)
    ),
    url(${({ backgroundImage }) => `"${encodeURI(backgroundImage)}"`}),
    url(${({ backgroundImage }) => `"${backgroundImage}"`});
  background-size: cover;
  background-position: center;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: end;

  @media (min-width: ${size.laptop}) {
    height: 175px;
  }
`

export const TripDetailsWrapper = styled.div`
  margin-right: 5px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  min-height: 100px;
  justify-content: flex-start;
  position: relative;
`

export const TripSecondaryDetailsWrapper = styled.div`
  margin-right: 5px;
  margin-bottom: 0px;
  padding: 10px;
  padding-top: 0px;
  display: flex;
  flex-direction: row;
  position: relative;
  text-align: left;
  flex-direction: column;
`

export const TripSecondaryDetailsItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

export const TripDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-bottom: 8px;
`

export const TripDescription = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 14px;
  font-weight: 400;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
`

export const RelevancyInfo = styled.span`
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  margin-bottom: 5px;
  line-height: 15px;
  padding: 2px 5px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
`

export const TripSecondaryDetails = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 15px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  padding: 0px;
  margin: 0;
  line-height: 16px;
  margin-right: 3px;
`

export const TitleWrapper = styled.div`
  width: fit-content;
  padding: 0px;
  border-radius: 3px;
  background-color: transparent;
  text-align: left;
  margin-bottom: 10px;
`

export const Title = styled.h3`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  font-size: 18px;
  font-weight: 600;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  padding: 0;
  margin: 0;
  text-align: left;
  text-transform: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug]
      .GRID_ITEMS_TITLE_TEXT_TRANSFORM};
`

export const TripSecondaryDetailItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-bottom: 8px;
  align-items: center;
`

export const TripSecondaryDetail = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 16px;
  font-weight: 400;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  display: flex;
  text-transform: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug]
      .GRID_ITEMS_TITLE_TEXT_TRANSFORM};
  align-self: center;
`

export const TripDuration = styled(TripSecondaryDetail)`
  font-size: 14px;
  font-weight: 600;
`

export const TripSecondaryDetailSeparator = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  width: 1px;
  height: 24px;
  background-color: #c2bfc3;
  margin: 0 5px;
`

export const TripDisclaimerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-bottom: 8px;
`

export const TripDisclaimer = styled.p`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 10px;
  font-weight: 400;
  color: #808080;
`

export const TripRatingWrapper = styled.span`
  display: inline-flex;
  align-items: center;
`

export const Location = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 15px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  right: 0px;
  line-height: 24px;
  font-weight: 700;
  text-transform: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug]
      .GRID_ITEMS_LOCATION_TEXT_TRANSFORM};
`

export const TripPriceWrapper = styled.div`
  width: auto;
  text-align: right;
`

export const TripPriceFlex = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
`

export const TripPrice = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  font-size: 32px;
  font-weight: 600;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
`

export const TripPriceSymbol = styled.span`
  display: inline-block;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  font-size: 18px;
  margin-right: 4px;
  margin-top: 4px;
  margin-bottom: 24px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
`

export const TripPriceDisclaimer = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  font-size: 12px;
  font-weight: 400;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  align-self: flex-end;
`

export const TripTypeOnCard = styled.div`
  position: relative;
  right: 0px;
  top: 0px;
  width: 28px;
  height: 22px;
  background-color: #028e00;
  border-radius: 4px;

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }
`

export const TripTypeLabelWrapper = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: -0.5px;
  position: relative;
`

export const TripTypeLabel = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  line-height: 22px;
  font-weight: 600;
`

export const GridTitle = styled.h2`
  position: inherit;
  top: unset;
  right: unset;
  background-color: unset;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  font-size: 32px;
  line-height: 36px;
  font-weight: 800;
  margin: 20px 0 15px;
  text-transform: capitalize;
  text-align: ${props => {
    return props?.isChatMode ? 'center' : 'left'
  }};

  @media (max-width: ${size.tablet}) {
    font-size: 24px;
    line-height: 28px;
    margin: 20px 0 15px;
  }
`

export const ShowMoreCta = styled.button`
  display: flex;
  outline: none;
  border-style: none;
  background-color: transparent;
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  cursor: pointer;
  padding: 7px 10px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  text-decoration: none;
  align-self: center;
  bottom: 0px;
  margin: 15px auto;
  align-self: stretch;
  text-decoration: underline;

  -webkit-transition: 0.25s ease;
  -moz-transition: 0.25s ease;
  -o-transition: 0.25s ease;
  transition: 0.25s ease;

  &:hover {
    transform: scale(1.025);
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  }

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }
`
